import { AfterViewInit, Component, EventEmitter, Inject, ViewChild } from '@angular/core';
import { IGrid } from 'bi-interfaces/lib/interfaces/IGrid';
import { IColumns } from 'bi-interfaces/lib/interfaces/IColumns.interface';
import { DataTypes } from 'bi-interfaces';
import { INavBtn } from 'bi-interfaces/lib/interfaces/inav-btn';
import { NavButton } from 'bi-interfaces';
import { SA_Attachments_Columns } from './bi-attachments-columns';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { BIModulesService } from '../../bi-modules.service';
import { DomSanitizer } from '@angular/platform-browser';
import { saveAs } from '@progress/kendo-file-saver';

@Component({
  selector: 'app-bi-attachments',
  templateUrl: './bi-attachments.component.html',
  styleUrls: ['./bi-attachments.component.scss', '../BI-Nav/bi-nav.component.scss'],
  providers: []
})
export class BiAttachmentsComponent implements AfterViewInit {
  @ViewChild('Header') BIGrid!: IGrid;
  ActionClicked = new EventEmitter<any>();

  data !: {
    BIGrid: IGrid,
    CanViewAttachments: boolean,
    CanAddAttachments: boolean,
    CanDeleteAttachments: boolean,
  }
  Params: {
    Name: string; Operator: string;
    value: string; DataType: DataTypes;
  }[] = [];

  isImage: boolean = false;
  isViewClicked: boolean = false;
  isUploadSuccessful: boolean = false;
  deleteConfirmMsg: boolean = true;

  file !: any
  UploadedFile !: any;

  //Header
  SA_Attachments_DataSource = this._datasource();
  SA_Attachments_changeset = this._changeset();
  SA_Attachments_columns: IColumns[];

  public navButtons: INavBtn = {
    [NavButton.attach]: {
      visibility: true,
      disable: false,
    },
    [NavButton.info]: {
      visibility: false,
      disable: false,
    },
  }

  constructor(@Inject('datasource') public _datasource: any,
    @Inject('changeset') public _changeset: any, private router: Router, public translateService: TranslateService,
    public biService: BIModulesService, public sanitizer: DomSanitizer

  ) {
    this.SA_Attachments_columns = SA_Attachments_Columns(this);
  }

  ngOnInit(): void {
    this.SA_Attachments_DataSource.APIURL = `SA_Attachments?$select=Serial,EntityName,EntityKey1,EntityKey2,EntityKey3,EntityKey4,EntityKey5,FileName,AttachmentComments`
    this.SA_Attachments_DataSource.POSTAPIURL = `SA_Attachments`
    this.SA_Attachments_DataSource.PUTAPIURL = `SA_Attachments`
    this.SA_Attachments_DataSource.DELETEAPIURL = `SA_Attachments`
    this.SA_Attachments_DataSource.Key = "Serial"
    this.SA_Attachments_DataSource.Columns = [
      { Name: "Serial", DataType: DataTypes.NUMERIC },
      { Name: "EntityName", DataType: DataTypes.Text },
      { Name: "EntityKey1", DataType: DataTypes.Text },
      { Name: "EntityKey2", DataType: DataTypes.Text },
      { Name: "EntityKey3", DataType: DataTypes.Text },
      { Name: "EntityKey4", DataType: DataTypes.Text },
      { Name: "EntityKey5", DataType: DataTypes.Text },
      { Name: "FileName", DataType: DataTypes.Text },
      { Name: "AttachmentBLOB", DataType: DataTypes.Text },
      { Name: "AttachmentComments", DataType: DataTypes.Text },
    ]
    this.SA_Attachments_DataSource.Type = 1 as any;
  }

  ngAfterViewInit(): void {
    this.BIGrid.BeforeActionSave = () => {
      if (this.BIGrid.CurrentSelectRow.controls['ChangeSet_Status'].getRawValue() != 'Add') {
        this.SA_Attachments_DataSource.excludeDataFromReq = ['AttachmentBLOB'];
      }
      this.BIGrid.AllowSave.next(true);
    }
    this.FilterAttachments();
    if (this.BIGrid) {
      this.SA_Attachments_DataSource.Params = this.Params;
    }
  }

  HeaderRowChange() {
    let extension = this.BIGrid.GetValueOf("FileName").split(".");
    if (["jpg", "png", "jpeg", "gif", "bmp"].find((element) => element == extension.at(-1))) {
      this.isImage = true;
    }
    else {
      this.isImage = false;
    }
  }

  FilterAttachments() {
    this.Params.push({
      Name: "EntityName", Operator: "eq",
      value: this.router.url.substring(this.router.url.indexOf('/', 2) + 1), DataType: DataTypes.Text
    });
    if (this.data.BIGrid.DataService.Key)
      this.Params.push({
        Name: "EntityKey1", Operator: "eq",
        value: this.data.BIGrid.GetValueOf(this.data.BIGrid.DataService.Key), DataType: DataTypes.Text
      });

    if (this.data.BIGrid.DataService.Key2)
      this.Params.push({
        Name: "EntityKey2", Operator: "eq",
        value: this.data.BIGrid.GetValueOf(this.data.BIGrid.DataService.Key2), DataType: DataTypes.Text
      });

    if (this.data.BIGrid.DataService.Key3)
      this.Params.push({
        Name: "EntityKey3", Operator: "eq",
        value: this.data.BIGrid.GetValueOf(this.data.BIGrid.DataService.Key3), DataType: DataTypes.Text
      });

    if (this.data.BIGrid.DataService.Key4)
      this.Params.push({
        Name: "EntityKey4", Operator: "eq",
        value: this.data.BIGrid.GetValueOf(this.data.BIGrid.DataService.Key4), DataType: DataTypes.Text
      });

    if (this.data.BIGrid.DataService.Key5)
      this.Params.push({
        Name: "EntityKey5", Operator: "eq",
        value: this.data.BIGrid.GetValueOf(this.data.BIGrid.DataService.Key5), DataType: DataTypes.Text
      });
  }

  UploadFile(event: any) {
    this.file = event.target.files[0];
    let fileReader: FileReader = new FileReader();

    fileReader.onload = (e: any) => {
      this.UploadedFile = e.target.result;
      if (this.UploadedFile) {
        this.ActionClicked.emit({ action: 'add' });
        this.BIGrid?.AddRow();
        this.BIGrid.SetValue("EntityName", this.router.url.substring(this.router.url.indexOf('/', 2) + 1), true);
        this.BIGrid.SetValue("EntityKey1", this.data.BIGrid.GetValueOf(this.data.BIGrid.DataService.Key)?.toString(), true);
        this.BIGrid.SetValue("EntityKey2", this.data.BIGrid.GetValueOf(this.data.BIGrid.DataService.Key2)?.toString(), true);
        this.BIGrid.SetValue("EntityKey3", this.data.BIGrid.GetValueOf(this.data.BIGrid.DataService.Key3)?.toString(), true);
        this.BIGrid.SetValue("EntityKey4", this.data.BIGrid.GetValueOf(this.data.BIGrid.DataService.Key4)?.toString(), true);
        this.BIGrid.SetValue("EntityKey5", this.data.BIGrid.GetValueOf(this.data.BIGrid.DataService.Key5)?.toString(), true);
        this.BIGrid.SetValue("FileName", this.file.name, true);
        this.BIGrid.SetValue("AttachmentBLOB", this.UploadedFile.split(",")[1], true);
      }
    }
    fileReader.readAsDataURL(this.file);
    this.BIGrid?.CurrentSelectRow?.enable({ emitEvent: false });
  }

  GetImage() {
    if (!this.BIGrid.GetValueOf("AttachmentBLOB")) {
      this.BIGrid.DataService.http.get(`SA_Attachments?$filter=Serial eq ${this.BIGrid.GetValueOf("Serial")}&$select=AttachmentBLOB`).
        subscribe((data: any) => {
          this.BIGrid.SetValue("AttachmentBLOB", data.value[0].AttachmentBLOB, false);
          this.UploadedFile = `data:image/${this.BIGrid.GetValueOf("FileName").split(".").at(-1)};base64,${data.value[0].AttachmentBLOB}`;
        })
    }
    else {
      this.UploadedFile = `data:image/${this.BIGrid.GetValueOf("FileName").split(".").at(-1)};base64,${this.BIGrid.GetValueOf("AttachmentBLOB")}`;
    }
  }

  async Download() {
    await this.GetImage();
    saveAs(this.UploadedFile, this.BIGrid.GetValueOf("FileName"));
  }

  async View() {
    await this.GetImage();
    this.isViewClicked = true;
  }

  ViewCanceled() {
    this.isViewClicked = false;
  }

  OnCancel() {
  }

  //#region Nav Functions

  /**
   * delete row from the grid
   * @return void
   */
  DeleteRow(): void {
    this.ActionClicked.emit({ action: 'delete' });
    if (this.deleteConfirmMsg) {
      Swal.fire({
        title: this.translateService.instant("ConfirmDelete"),
        icon: 'warning',
        showCloseButton: true,
        showCancelButton: true,
        buttonsStyling: false,
        customClass: {
          cancelButton: 'cancelSweatAlert',
          confirmButton: "confirmSweatAlert",
          title: "titleSweatAlert",
          icon: "iconSweatAlert"
        },
        width: 400,
        focusConfirm: false,
        confirmButtonText: this.translateService.instant("yes"),
        cancelButtonText: this.translateService.instant("Cancel"),
      }).then(res => {
        if (res.isConfirmed) {
          this.BIGrid?.DeleteRow();

        }
      })
    }
    else
      this.BIGrid?.DeleteRow();

  };
  /**
   * save edits in any cell
   * @return void
   */
  Cancel(): void {
    this.ActionClicked.emit({ action: 'cancel' });
    this.BIGrid?.Cancel();
  };
  /**
   * save edits in any cell
   * @return void
   */
  Save(): void {
    this.ActionClicked.emit({ action: 'save' });
    if (this.BIGrid?.CheckPendingChange()) {
      this.BIGrid.Save();
    }
  };
  //#endregion
}
